export default "__VITE_ASSET__CDYsCv09__"